import React from "react";

export const BuroCard = ({
  titulo,
  cantidad,
  indicador,
  texto,
  porcentaje,
  className,
  onClick,
  activo = false,
}) => {
  const containerClassName =
    className === undefined
      ? "buro-container-resumen-item"
      : className;
  return (
    <div className={containerClassName} onClick={onClick}>
      <div
        className={`${"buro-container-resumen-item-box"} ${
          activo === false
            ? "buro-container-resumen-item-box-green"
            : "buro-container-resumen-item-box-yellow"
        } `}
        style={{ width: "180px"}}
      >
        <div className="buro-container-resumen-title">
          {titulo}
        </div>
        <div className="buro-container-resumen-valor">
          {cantidad}
        </div>
        <div className="buro-container-resumen-porcentaje">
          {porcentaje}
        </div>
      </div>
    </div>
  );
};
